import React, { useState, useEffect } from 'react';
import styles from './viewCustomEvaluation.module.scss';
import { Col, Row, Form, Card, Button, Accordion, Tab, Tabs } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { Route, Switch, Navigate, NavLink } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';
import { useParams, useNavigate } from 'react-router-dom';
import CSSLoader from '../../../shared/cssLoader';
import { getCustomEvaluationTask } from '../../../../services/util/customEvaluation';
import { submitCustomEvaluationTask } from '../../../../services/util/customEvaluation';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga4';
import Avatar from 'react-avatar';
import CustomNavbar from '../../customNavbar';
import { CustomButton } from '../../../shared/customButton';
import { CustomDropdown } from '../../../shared/customDropdown';
import { CustomConfirmationModal } from '../../../shared/customConfirmationModal';
import { CustomAlertBox } from '../../../shared/customAlertBox';
// import Tab from 'react-bootstrap/Tab';
// import Tabs from 'react-bootstrap/Tabs';
import StarRating from '../../../shared/rate'
import CandidateCvView from '../../common/candidateCvView';
import CandidateCoverLetterView from '../../common/candidateCoverLetterView';
import CandidateAnswersToCustomQuestionsView from '../../common/candidateAnswersToCustomQuestionsView';
import AddCandiateNoteModal from '../../common/addCandidateSpecialNoteModal';
import { CustomConfirmationBox } from '../../../shared/customConfirmationBox';
import { failCandidateManually } from '../../../../services/util/hiringpipeline/candidates';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`


const ViewCustomEvaluation = (props) => {
    let [numPages, setNumPages] = useState(null);
    let [pageNumber, setPageNumber] = useState(1);
    let [isLoading, setLoading] = useState(false);
    let [emptyCommentsError, setEmptyCommentsError] = useState(false);
    let [emptyMarksError, setEmptyMarksError] = useState(false);
    let [emptyOverallMarksError, setEmptyOverallMarksError] = useState(false);
    let [outOfRangeOverallMarksError, setOutOfRangeOverallMarksError] = useState(false);
    const [isSubmit, setSubmit] = useState(false)
    const [defaultScale, setDefaultScale] = useState(1.6);
    const [isModalOpen, setModalOpen] = useState(false);
    const [defaultScalePrecentage, setScalePrecentage] = useState(100);
    let [accordionIcon, setAccordionIcon] = useState(true);
    let [dropdownError, setDropDownError] = useState();
    let [isURLLoading, setURLLoading] = useState(false);
    const [reviewCriteriaRating, setReviewCriteriaRating] = useState([]);
    let [state, setState] = useState({
        comments: []
    });
    let [marks, setMarks] = useState(-1)
    let { id } = useParams();
    let [candidateValues, setCandidateValues] = useState({
        candidate_id: '',
        candidate_first_name: '',
        candidate_last_name: '',
        cv_url: null,
        cover_letter_url: null,
        evaluation_criteria: '',
        pipeline_stage_name: '',
        cv_review_session_id: null,
        custom_question_answers: [],
        review_criteria: [],
        custom_evaluation_description: '',
        pipeline_step:''
    });
    const [cvObject, setCVObject] = useState({ url: null })
    let [specialNoteModalOpen, setSpecialNoteModalOpen] = useState(false);

    let history = useNavigate();
    const options = {
        cMapUrl: 'cmaps/',
        cMapPacked: true,
    };
    const [calOverallMark, setCalOverallMark] = useState(null);
    const breadcrumb = [
        {
            pathaddress: '/app/company/custom-evaluations',
            pathname: 'Custom Evaluations',
            isActive: false,
            key: 2 + 'custom-evaluation'
        },
        {
            pathaddress: '',
            pathname: candidateValues.candidate_first_name + ' ' + candidateValues.candidate_last_name,
            isActive: true,
            key: 3 + candidateValues.candidate_first_name + '-' + candidateValues.candidate_last_name
        },
    ]

    const breacrumbText = 'Complete your evaluation and submit your feedback. If the overall score is higher than the passing threshold, the candidate will move forward.'
    let [isRejectedWithoutMarksModalOpen, setIsRejectedWithoutMarksModalOpen] = useState(false);
    let [actionsSubmitLoading, setActionsSubmitLoading] = useState(false);

    let main_props = {
        permissions: props.permissions,
        role: props.role,
        toggleInterviewView: props.toggleInterviewView
    }

    const schema = yup.object({
        comments: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required'),
    });

    function nextPage() {
        if (pageNumber !== numPages) {
            setPageNumber(prevState => prevState + 1);
        }
    }

    function prevPage() {
        if (pageNumber !== 1) {
            setPageNumber(prevState => prevState - 1);
        }
    }

    //dropdown values
    const dropValue = [
        {
            label: '--SELECT--',
            value: -1,
        },
        {
            label: '1',
            value: 1,
        },
        {
            label: '2',
            value: 2,
        },
        {
            label: '3',
            value: 3,
        },
        {
            label: '4',
            value: 4,
        },
        {
            label: '5',
            value: 5,
        },
        {
            label: '6',
            value: 6,
        },
        {
            label: '7',
            value: 7,
        },
        {
            label: '8',
            value: 8,
        },
        {
            label: '9',
            value: 9,
        },
        {
            label: '10',
            value: 10,
        },
    ]


    //on adding comments function
    const onSubmit = async (values, { resetForm }) => {
        setEmptyCommentsError(false)
        addComment(values.comments);
        resetForm({ comments: '' });
    }

    //add comment function
    function addComment(item) {
        setState(state => ({
            comments: [...state.comments, item]
        }));
    }
    //remove comment function
    function removeComment(item) {
        let array = [state.comments];
        if (item !== -1) {
            array[0].splice(item, 1);
            setState({
                comments: array[0]
            })
        }
    }

    //on pdf load success
    function onDocumentLoadSuccess({ numPages: nextNumPages }) {
        setNumPages(nextNumPages);
    }

    function checkValidationAndOpenModal() {
        //using "marks" for older pipes and "overallmarks" for more recent pipelines
        //check whether comments and marks(calOverallMark or marks) null
        if (state.comments.length >= 0 && ((calOverallMark > -1 && calOverallMark < 101 && calOverallMark != "" && calOverallMark !== null) || marks !== -1)) {
            setOutOfRangeOverallMarksError(false);
            setModalOpen(true);
        }
        else {
            if (marks === -1) {
                setEmptyMarksError(true)
            }
            if (calOverallMark < 0 || calOverallMark > 100 || calOverallMark === null || calOverallMark == "") {
                setOutOfRangeOverallMarksError(true)
            }
        }
    }

    //submit values function
    async function submitValues() {
        if (state.comments.length >= 0 && (calOverallMark !== null || marks !== -1)) {
            const reviewCriteriaData = [];
            for (let key in candidateValues.review_criteria) {
                for (let keys in reviewCriteriaRating) {
                    if (candidateValues.review_criteria[key].label === reviewCriteriaRating[keys].label) {
                        if (reviewCriteriaRating[keys].rate !== 0) {
                            const newOverallRating = {
                                _id: candidateValues.review_criteria[key]._id,
                                label: candidateValues.review_criteria[key].label,
                                rate: reviewCriteriaRating[keys].rate,
                            }
                            reviewCriteriaData.push(newOverallRating)
                        }
                    }
                }
            }
            setSubmit(true)
            //convert marks to 100% and assign to score
            let score = calOverallMark !== null ? calOverallMark : (marks * 10).toFixed(1);
            let respond = await submitCustomEvaluationTask(id, score, state.comments, reviewCriteriaData ? reviewCriteriaData : null)

            if (respond.success === true) {
                props.GetTaskValues();
                history(`/company/custom-evaluations/group?step_id=${candidateValues.step_id}`);
                setSubmit(false);
            } else {
                setSubmit(false);
            }
        } else {
            if (marks === -1) {
                setEmptyMarksError(true)
            }
            if (calOverallMark === null) {
                setEmptyOverallMarksError(true);
            }
        }
    }

    const changeAccordionIcon = () => {
        setAccordionIcon(!accordionIcon);
    }



    //load user values
    const getCustomEvaluationDetails = async () => {
        setLoading(true)
        let respond = await getCustomEvaluationTask(id)
        if (respond.success === true) {
            await setCandidateValues(respond.data)
            await setCVObject({
                url: respond.data.cv_url
            })
            setLoading(false)
        } else {
            setLoading(false)
            history('/company/custom-evaluations')
        }
    }

    const handleRatingChange = (id, rating, label) => {
        let data = {
            rate: rating,
            label: label,
        }
        setReviewCriteriaObj(data);
    };
    const setReviewCriteriaObj = (data) => {
        const reviewCriteriaList = [...reviewCriteriaRating];
        if (reviewCriteriaRating.length === 0) {
            setReviewCriteriaRating(current => ([...current, data]));
        }
        else {
            let reviewRating = reviewCriteriaList.find(reviewCriteriaRating => reviewCriteriaRating.label === data.label);
            if (reviewRating) {
                reviewRating.rate = data.rate === null ? 0 : data.rate;
                setReviewCriteriaRating(reviewCriteriaList);
            }
            else {
                setReviewCriteriaRating(current => ([...current, data]));
            }
        }
    }

    //open and close note modal
    const openSpecialNoteModal = () => {
        setSpecialNoteModalOpen(true);
    }

    const closeSpecialNoteModal = () => {
        setSpecialNoteModalOpen(false);
    }

    useEffect(() => {
        getCustomEvaluationDetails();
    }, []);

    useEffect(() => {
        calculateMarks();
    }, [reviewCriteriaRating])

    const calculateMarks = () => {
        var results = 0;
        var addition = 0;
        var divider = 0;
        for (let key in reviewCriteriaRating) {
            if (reviewCriteriaRating[key].rate !== 0) {
                addition += reviewCriteriaRating[key].rate;
                divider += 1;
            }
        }
        if (addition !== 0) {
            results = (addition / (divider * 5)) * 100;
        }
        setCalOverallMark(results === 0 ? null : results.toFixed(1))
    };
    useEffect(() => {
        let pageHit = '/app/company/custom-evaluations';
        ReactGA.initialize(`${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`);
        ReactGA.send({ hitType: "pageview", page: pageHit});
    }, [])

    function viewCandidate(val) {
        let path = `/app/company/candidate`;
        let search = 'cid=' + val;

        const url = `${path}?${search}`;
        window.open(url);
    }
    const manuallyFailCandidateWithoutMarks = async (value) => {
        setActionsSubmitLoading(true);
        let candidate_id =[];
        candidate_id.push(candidateValues.candidate_id) 
        let respond = await failCandidateManually(candidate_id, candidateValues.pipeline_step, value.reason);
        if (respond.success === true) {
            setActionsSubmitLoading(false);
            setIsRejectedWithoutMarksModalOpen(false);
            props.GetTaskValues();
            history(`/company/custom-evaluations`);
        } else {
            setActionsSubmitLoading(false);
            setIsRejectedWithoutMarksModalOpen(false);
        }
    };


    return (
        <div>
            <Helmet>
                <title>Custom Evaluation | HireTrace</title>
            </Helmet>
            {!candidateValues.cv_url && isLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>
                    <CustomConfirmationBox
                        show={isRejectedWithoutMarksModalOpen}
                        cancelIconclick={() => setIsRejectedWithoutMarksModalOpen(false)}
                        onSecondaryBtnClick={() => setIsRejectedWithoutMarksModalOpen(false)}
                        onFormSubmit={manuallyFailCandidateWithoutMarks}
                        isSecondaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                        isPrimaryBtnDisabled={actionsSubmitLoading === true ? true : false}
                        primaryBtnBackSideIcon={actionsSubmitLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        topic="Are you sure?"
                        message="You are trying to reject selected candidate from the pipeline. Candidate overall status will be failed."
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="defaultBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="submit"
                        primaryBtnCssType="dangerBtn"
                        primaryBtnLabel="Yes, reject candidate"
                        checkboxLabel="I confirm to manually reject selected candidate from the pipeline"
                    />

                    {/* submit result alert confirmation start */}
                    <CustomConfirmationModal
                        show={isModalOpen}
                        confirmationType='success'
                        cancelIconclick={() => setModalOpen(false)}
                        onSecondaryBtnClick={() => setModalOpen(false)}
                        onPrimaryBtnClick={submitValues}
                        isSecondaryBtnDisabled={isSubmit === true ? true : false}
                        isPrimaryBtnDisabled={isSubmit === true ? true : false}
                        primaryBtnBackSideIcon={isSubmit === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        confirmationTopic="Are you sure?"
                        confirmationMessage="Your feedback cannot change later."
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="primaryBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnType="button"
                        primaryBtnCssType="successBtn"
                        primaryBtnLabel="Yes, Submit!"
                    />
                    {/* submit result alert confirmation end */}

                    {/* add note modal open */}
                    {specialNoteModalOpen &&
                        <AddCandiateNoteModal showModal={specialNoteModalOpen} handleClose={() => setSpecialNoteModalOpen(false)} candidateID={candidateValues.candidate_id} />
                    }
                    {/* add note modal close */}

                    {/* Alert Box End */}
                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} breacrumbText= {breacrumbText}/>
                    </div>

                    {/* <Row className={styles.bodyRow}>
                        <Col md={7} lg={8} xl={9} className={styles.leftSideRow}> */}

                    {/* candidate review details */}
                    <Row>
                        <Col>
                            <div className={styles.reviewDetails}>
                                <Row>
                                    <Col md={1} lg={1} xl={1} className={styles.candidatePhoto}>
                                        <Avatar src={candidateValues.candidate_photo_url} name={candidateValues.candidate_first_name + ' ' + candidateValues.candidate_last_name} size="90" round={false} />
                                    </Col>
                                    <Col md={11} lg={11} xl={11} className={styles.candidateDetails}>
                                        <Row>
                                            <Col sm={5}>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Name : </span><span className={styles.reviewDetailsValue}>{candidateValues.candidate_first_name + ' ' + candidateValues.candidate_last_name}</span> <i onClick={() => viewCandidate(candidateValues.candidate_id)} class="fas fa-external-link-alt ml-1S" id={styles.openInNewtabIcon}></i> </p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Email : </span><span className={styles.reviewDetailsValue}>{candidateValues.candidate_email}</span></p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Mobile : </span><span className={styles.reviewDetailsValue}>{`(${candidateValues.candidate_mobile_country_code}) ${candidateValues.candidate_mobile_number}`}</span></p>
                                            </Col>
                                            <Col sm={5}>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Pipeline : </span><span className={styles.reviewDetailsValue}>{candidateValues.pipeline_name}</span></p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Position : </span><span className={styles.reviewDetailsValue}>{candidateValues.hiring_position}</span></p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Passing Threshold : </span><span className={styles.reviewDetailsValue}>{candidateValues.minimum_pass_score}%</span></p>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Review Criteria : </span><span className={styles.reviewDetailsValue}>{candidateValues.evaluation_criteria ? candidateValues.evaluation_criteria : "N/A"}</span></p>
                                                <p className={styles.reviewDetailsItem}><span className={styles.reviewDetailsLabel}>Evaluation Description : </span><span className={styles.reviewDetailsValue}>{candidateValues.custom_evaluation_description ? candidateValues.custom_evaluation_description : "N/A"}</span></p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>

                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <div className={styles.reviewAreaBox}>
                                <Col>
                                    <Row >
                                        <Col md={7} lg={8} xl={9} className={styles.reviewAreaLeft}>


                                            {/* view cv , cover letter and Custom Questions  */}
                                            <Tabs
                                                defaultActiveKey="cv"
                                                id="controlled-tab-example"
                                                className={styles.tabGroup}
                                            >
                                                <Tab eventKey="cv" title="CV" tabClassName={styles.tabItem} >

                                                    <CandidateCvView candidateValues={candidateValues} stepId={id} cvURL={candidateValues.cv_url} candidateID={candidateValues.candidate_id}
                                                    />
                                                </Tab>
                                                {candidateValues.cover_letter_url ? <Tab eventKey="CoverLetter" title="Cover Letter" tabClassName={styles.tabItem}>
                                                    <CandidateCoverLetterView candidateValues={candidateValues} stepId={id} coverLetterURL={candidateValues.cover_letter_url} candidateID={candidateValues.candidate_id} />
                                                </Tab> : null}
                                                {candidateValues.custom_question_answers && candidateValues.custom_question_answers.length > 0 ?
                                                    <Tab eventKey="customQuestions" title="Custom Questions" tabClassName={styles.tabItem}>
                                                        <CandidateAnswersToCustomQuestionsView candidateValues={candidateValues} />
                                                    </Tab> : null}
                                            </Tabs>
                                        </Col>
                                        <Col className={styles.reviewSubmissionColumn} md={5} lg={4} xl={3}>

                                            <Card className={styles.reviewSubmissionCard}>
                                                <Card.Header className={styles.reviewSubmissionCardHeader}>
                                                    <div className={styles.reviewSubmissionCardheaderDetails}>
                                                        <p className={styles.reviewSubmissionCardHeaderTopic}>Submit Feedback</p>
                                                    </div>
                                                </Card.Header>
                                                <Card.Body>
                                                    <div>
                                                        <div>
                                                            <div className={styles.addNoteDiv}>
                                                                <p className={styles.noteValue} onClick={() => openSpecialNoteModal()}>Add special note</p>
                                                            </div>
                                                            {candidateValues.review_criteria.length ?
                                                                <div className='mt-n4'>
                                                                    <p className={styles.reviewFeedbackLabel}>Feedback</p>
                                                                    {candidateValues.review_criteria.map((item, i) => (
                                                                        <Card className={styles.reviewFeedbackBox} key={i}>

                                                                            <Card.Body className={styles.reviewFeedbackBoxBody}>
                                                                                <span className={styles.reviewFeedbackInnerBox}>
                                                                                    <span className={styles.reviewFeedbackValue}>{item.label}</span>
                                                                                    <span className={styles.reviewFeedbackStars}><StarRating className="mr-4" disabled={false} id={i} onRatingChange={(reviewCriteriaRating) => {handleRatingChange(i, reviewCriteriaRating, item.label); setOutOfRangeOverallMarksError(false)}} /></span>
                                                                                </span>
                                                                            </Card.Body>
                                                                        </Card>
                                                                    ))
                                                                    }
                                                                    <p className={styles.reviewFeedbackOverallScore}><span className={styles.reviewFeedbackOverallScoreLabel}>Overall Marks : </span><span className={styles.reviewFeedbackOverallScoreLabelValue}>{(calOverallMark && calOverallMark > 0) ? calOverallMark : 0}%</span></p>

                                                                    {(outOfRangeOverallMarksError === true) &&
                                                                        <p className={styles.reviewErrorMsg}> You have to give at least one star rating.</p>
                                                                    }
                                                                </div>
                                                                :
                                                                <div>
                                                                    <Formik
                                                                        initialValues={{ marks: marks }}>

                                                                        {({
                                                                            values,
                                                                            errors,
                                                                            setFieldValue,
                                                                            handleSubmit,
                                                                            submitCount
                                                                        }) => (
                                                                            <div>
                                                                                <Form noValidate onSubmit={handleSubmit}>
                                                                                    <CustomDropdown
                                                                                        label="Overall Marks"
                                                                                        classLabel="defaultLabel"
                                                                                        labelDesc="Score candidate 1 to 10. 1 is lowest, 10 is highest."
                                                                                        controlId="marks"
                                                                                        name="marks"
                                                                                        value={values.marks}
                                                                                        handleOnChange={(e) => { setFieldValue('marks', e.target.value); setMarks(parseInt(e.target.value)) }}
                                                                                        dropdownValues={dropValue}
                                                                                        errorMessage={dropdownError}
                                                                                        onFocus={() => setEmptyMarksError(false)}
                                                                                        isInvalid={emptyMarksError}
                                                                                    />
                                                                                </Form>
                                                                                {(emptyMarksError === true && marks === -1) &&
                                                                                    <p className={styles.reviewErrorMsg}> Select Valid Mark.</p>
                                                                                }
                                                                            </div>
                                                                        )}
                                                                    </Formik>
                                                                </div>
                                                            }

                                                        </div>
                                                    </div>


                                                    <Formik
                                                        validationSchema={schema}
                                                        onSubmit={(values, resetForm) => onSubmit(values, resetForm)}
                                                        initialValues={{}}>

                                                        {({
                                                            values,
                                                            errors,
                                                            setFieldValue,
                                                            handleChange,
                                                            handleSubmit,
                                                            submitCount,
                                                            resetForm
                                                        }) => (
                                                            <div>

                                                                <Form noValidate onSubmit={handleSubmit}>
                                                                    <Form.Group controlId="comments">
                                                                        <Form.Label className={styles.reviewCommentsLabel}>Comments</Form.Label>
                                                                        <Form.Control as="textarea" name="comments" value={values.comments || ''} onChange={(e) => { setFieldValue('comments', e.target.value); }} rows={3} className={styles.reviewCommentsBox} isInvalid={errors.comments || emptyCommentsError} onFocus={() => setEmptyCommentsError(false)} />
                                                                        <p className={styles.reviewErrorMsg}>{errors.comments}</p>
                                                                    </Form.Group>
                                                                    <div className={styles.reviewCommentsAddBtnBox}>
                                                                        <CustomButton
                                                                            id="add_comment"
                                                                            buttonType="submit"
                                                                            label="Add Comment"
                                                                            type="secondaryBtn"
                                                                            frontIcon={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                                                <path d="M9.99984 4.22156V15.8882M4.1665 10.0549H15.8332" stroke="#2790A6" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </svg>}
                                                                            handleClick={handleChange}
                                                                        />

                                                                    </div>

                                                                    <div className='mb-1 pb-1'>
                                                                        {
                                                                            state.comments.map((item, i) => (
                                                                                <Row className='m-0 p-1'>
                                                                                    <Col sm={11} className='m-0 p-0'>
                                                                                        <Card className={styles.reviewCommentBox} key={i}>
                                                                                            <Card.Body className={styles.reviewCommentBoxBody}>
                                                                                                <span className={styles.reviewCommentsInnerBox}>
                                                                                                    <span className={styles.reviewCommentValue}>{item}</span>
                                                                                                </span>
                                                                                            </Card.Body>
                                                                                        </Card>
                                                                                    </Col>
                                                                                    <Col sm={1} className={styles.reviewCommentSecondCol}>
                                                                                        <span className={styles.cancelIconDiv} onClick={() => removeComment(i)} key={(props.keyValue) + 1}>
                                                                                            <svg className={styles.cancelIcon} width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                <g id="trash-01">
                                                                                                    <path id="Icon" d="M13.3333 5.49999V4.83332C13.3333 3.8999 13.3333 3.43319 13.1517 3.07667C12.9919 2.76307 12.7369 2.5081 12.4233 2.34831C12.0668 2.16666 11.6001 2.16666 10.6667 2.16666H9.33333C8.39991 2.16666 7.9332 2.16666 7.57668 2.34831C7.26308 2.5081 7.00811 2.76307 6.84832 3.07667C6.66667 3.43319 6.66667 3.8999 6.66667 4.83332V5.49999M8.33333 10.0833V14.25M11.6667 10.0833V14.25M2.5 5.49999H17.5M15.8333 5.49999V14.8333C15.8333 16.2335 15.8333 16.9335 15.5608 17.4683C15.3212 17.9387 14.9387 18.3212 14.4683 18.5608C13.9335 18.8333 13.2335 18.8333 11.8333 18.8333H8.16667C6.76654 18.8333 6.06647 18.8333 5.53169 18.5608C5.06129 18.3212 4.67883 17.9387 4.43915 17.4683C4.16667 16.9335 4.16667 16.2335 4.16667 14.8333V5.49999" stroke="#B42318" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                </g>
                                                                                            </svg>
                                                                                        </span>
                                                                                    </Col>
                                                                                </Row>



                                                                            ))
                                                                        }
                                                                    </div>

                                                                </Form>
                                                            </div>
                                                        )}
                                                    </Formik>

                                                    <div className='mt-3'> 
                                                        <CustomButton
                                                            buttonType="submit"
                                                            type="primaryBtn"
                                                            label="Submit Marks and Feedback"
                                                            disabled={isSubmit === true ? true : false}
                                                            handleClick={checkValidationAndOpenModal}
                                                        />
                                                    </div>
                                                   
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                        </Col>
                    </Row>

                </div>)
            }
        </div >
    )
}

export default ViewCustomEvaluation;